import React, { useRef, useState } from 'react';
import styles from './index.module.scss';

export enum directions {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
  NONE = 'none'
}

export interface TimeoutProps {
  children: React.ReactNode;
  delay?: number;
  wrapperClassName?: string;
  direction?: directions;
  content: string | React.ReactNode;
  showToolTip?: boolean;
  onMouseEnterCallback?: () => void;
  // smartHandling: boolean; // if true - Then it will
}

const Tooltip = (props: TimeoutProps) => {
  const { showToolTip = true, onMouseEnterCallback } = props;
  const timeout = useRef<ReturnType<typeof setInterval>>();
  const [active, setActive] = useState(false);

  const showTip = () => {
    onMouseEnterCallback && onMouseEnterCallback();
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      setActive(true);
    }, props.delay || 0);
  };

  const hideTip = () => {
    clearTimeout(timeout.current);
    setActive(false);
  };

  return (
    <div className={styles.TooltipWrapper} onMouseEnter={showTip} onMouseLeave={hideTip} {...props}>
      {props.children}
      {active && showToolTip && (
        <div
          className={`${props.wrapperClassName} ${styles.TooltipTip} ${
            styles[props.direction || directions.NONE]
          }`}
        >
          {props.content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
